<template>
  <el-container class="page_layout_container">
    <el-header height="80px" class="header_container">
      <div class="header w1200">
        <div class="left_container">
          <div class="website_name" @click="handleClickWebsite">{{ setting.cms_website_name || '' }}</div>
            <div class="column_item" v-for="(item, index) in topColumnList" :key="index"
                 @click="handleClickItem(item)">
              <template v-if="isNotEmpty(item.icon_url)">
                <el-image :src="item.icon_path" class="column_icon" />
              </template>
              <span>{{ item.name }}</span>
            </div>
        </div>
        <div class="right_container">
          <div class="search_container">
            <el-select size="default" v-model="searchArea" class="search_select"
                       :suffix-icon="suffixIcon">
              <el-option :label="currColumn.name" value="curr" />
              <el-option label="本站" value="all" />
            </el-select>
            <el-input size="default" type="text" class="search_input" clearable
                      v-model="searchValue" placeholder="请输入查询内容"
                      @keyup.enter.native="handleSearch()" @change="handleChange">
              <template #append>
                <svg-icon icon-class="icon-search" class-name="search_icon"
                          @click="handleSearch()" />
              </template>
            </el-input>
          </div>
          <div class="login_container">
            <template v-if="isLogined">
              <el-dropdown size="large" @command="handleDropdownCommand">
                <div class="dropdown_text">
                  <div class="login_icon">
                    <template v-if="isNotEmpty(headPicUrl)">
                      <el-image :src="headPicUrl" class="img" />
                    </template>
                    <template v-else>
                      <svg-icon icon-class="icon-user" />
                    </template>
                  </div>
                  <div class="login_name">{{ userInfo.name }}</div>
                </div>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item command="info">个人信息</el-dropdown-item>
                    <el-dropdown-item command="change_pwd" v-if="isNotEmpty(userInfo.login_id)">修改密码</el-dropdown-item>
                    <el-dropdown-item command="account_setting" v-else>设置账号</el-dropdown-item>
                    <el-dropdown-item divided command="logout">退出登录</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </template>
            <template v-else>
              <div class="login_icon">
                <svg-icon icon-class="icon-user" />
              </div>
              <div class="login_name" @click="handleOpenLogin">登录</div>
            </template>
          </div>
        </div>
      </div>
    </el-header>
    <el-main class="content_layout_container">
      <router-view @event="handleRouterViewEvent" />
      <el-backtop target=".content_layout_container" :visibility-height="50" />

      <template v-if="isNotEmpty(setting.cms_copyright)">
        <el-footer class="footer_container" height="90px">
          <div class="footer w1200">
            <span>{{ setting.cms_copyright }}</span>&nbsp;&nbsp;<span v-html="setting.beian_html"></span>
          </div>
        </el-footer>
      </template>
    </el-main>

    <login-dialog ref="loginDialog" @event="handleDialogEvent" />
    <reg-user-dialog auto-login ref="regUserDialog" @event="handleDialogEvent" />
    <reg-user-info-dialog ref="regUserInfoDialog" />
    <change-password-dialog ref="changePasswordDialog" />
    <account-setting-dialog ref="accountSettingDialog" />
  </el-container>
</template>

<script>
import { mapState } from "vuex";
import { defineAsyncComponent, markRaw } from 'vue';
import { CaretTop } from '@element-plus/icons-vue';
import { loadJs } from "@/utils/loadResources";

export default {
  name: "Layout",
  components: {
    LoginDialog: defineAsyncComponent(() => import('@components/dialog/LoginDialog')),
    RegUserDialog: defineAsyncComponent(() => import('@components/dialog/RegUserDialog')),
    RegUserInfoDialog: defineAsyncComponent(() => import('@components/dialog/RegUserInfoDialog')),
    ChangePasswordDialog: defineAsyncComponent(() => import('@components/dialog/ChangePasswordDialog')),
    AccountSettingDialog: defineAsyncComponent(() => import('@components/dialog/AccountSettingDialog')),
  },
  data() {
    return {
      columnList: [],
      searchValue: '',
      searchArea: '',
      suffixIcon: markRaw(CaretTop),
    };
  },
  computed: {
    ...mapState([ 'setting', 'currColumn', 'userInfo' ]),
    ...mapState('techBlue', [ 'search_value' ]),
    isLogined() {
      return this.userInfo && this.isNotEmpty(this.userInfo.sid);
    },
    addBdTongJi() {
      if (this.setting.cms_add_bdtongji === 1) {
        return this.isNotEmpty(this.setting.cms_bdtongji_code);
      }
      return false;
    },
    topColumnList() {
      return this.columnList.filter(item => item.location === 'top');
    },
    headPicUrl() {
      if (this.isNotEmpty(this.userInfo.head_pic)) {
        let head_pic = this.userInfo.head_pic;
        if (this.isNotEmpty(head_pic) && head_pic.indexOf('http://') === -1
            && head_pic.indexOf('https://') === -1) {
          head_pic = this.getFileUrl(head_pic);
        }
        return head_pic;
      }
      return '';
    }
  },
  watch: {
    $route: {
      handler() {
        this.init();
      },
      deep: true,
      immediate: true,
    },
    search_value: {
      handler() {
        this.searchValue = this.search_value;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    async init() {
      if (this.$route.path.indexOf('/app') === 0) {
        return;
      }
      $('html').removeClass('app');
      await this.wechatLogin();
      await this.storeDispatch('initCmsSetting');
      if (this.addBdTongJi) {
        loadJs(`https://hm.baidu.com/hm.js?${ this.setting.cms_bdtongji_code }`);
      }
      await this.initColumnList();
      this.searchValue = this.search_value || '';
      this.searchArea = 'curr';
    },
    async wechatLogin() {
      const _this = this;
      if (_this.isLogined && _this.isNotEmpty(_this.userInfo.open_id)) {
        return;
      }
      if (_this.$utils.isNotEmpty(window.configs.wx_login_code)) {
        let data = {
          access_code: window.configs.wx_login_code,
        };
        if (_this.isNotEmpty(_this.userInfo.sid)) {
          data.user_sid = _this.userInfo.sid;
        }
        let res = await _this.fetchData(_this.$api.API_GetOpenId, data).catch(err => err);
        if (res.code === 0) {
          let resData = res.data || {};
          if (resData.accessToken) {
            _this.storeCommit('SET_USER_INFO', resData);
            _this.storeCommit('SET_ACCESS_TOKEN', resData.accessToken);
          }
          window.configs.wx_login_code = undefined;
        }
      }
      if (_this.$utils.isNotEmpty(window.configs.xcx_login_code)) {
        let code = window.configs.xcx_login_code;
        let res = await _this.fetchData(_this.$api.API_LoginByXcx, { code }).catch(err => err);
        if (res.code === 0) {
          let resData = res.data || {};
          if (resData.accessToken) {
            _this.storeCommit('SET_USER_INFO', resData);
            _this.storeCommit('SET_ACCESS_TOKEN', resData.accessToken);
          }
          window.configs.xcx_login_code = undefined;
        }
      }
    },
    handleClickWebsite() {
      this.$router.push('/');
    },
    initColumnList() {
      let _this = this;
      return _this.fetchData(_this.$api.API_GetCmsColumnList).then(result => {
        _this.columnList = result.data || [];
        if (_this.isNotEmptyList(_this.columnList)) {
          _this.columnList.forEach(item => {
            if (_this.isNotEmpty(item.icon_url)) {
              item.icon_path = _this.getFileUrl(item.icon_url);
            }
          });
        }
        _this.storeCommit('SET_COLUMN_LIST', _this.columnList);
        if (_this.isNotEmpty(_this.currColumn.sid)) {
          let filter = _this.columnList.filter(item => item.sid === _this.currColumn.sid);
          if (!_this.isNotEmptyList(filter)) {
            _this.storeCommit('SET_CURR_COLUMN', _this.columnList[0]);
          }
        } else {
          _this.storeCommit('SET_CURR_COLUMN', _this.columnList[0]);
        }
      }).catch(() => {
      });
    },
    handleRouterViewEvent(event) {
    },
    handleOpenLogin() {
      const _this = this;
      let browserInfo = _this.$utils.getBrowserInfo();
      if (browserInfo.miniProgram) {
        // 微信小程序web-view打开
        let route = _this.$XEUtils.locat();
        wx.miniProgram.redirectTo({
          url: '/pages/index/index?op=login&href=' + route.href,
        });
        return;
      }
      if (browserInfo.weixin) {
        // 微信浏览器打开
        _this.fetchData(_this.$api.API_GetOpenId).then(res => {
          let resData = res.data || {};
          let route = _this.$XEUtils.locat();
          window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + resData.app_id
              + '&redirect_uri=' + encodeURIComponent(route.href)
              + '&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect';
        }).catch(() => {
        });
        return;
      }
      if (_this.$refs['loginDialog']) {
        _this.$refs['loginDialog'].openDialog({});
      }
    },
    handleDialogEvent(event) {
      if (event.type === 'regUser') {
        if (this.$refs['regUserDialog']) {
          this.$refs['regUserDialog'].openDialog({});
        }
        return;
      }
      if (event.type === 'autoLogin') {
        if (this.$refs['loginDialog']) {
          this.$refs['loginDialog'].closeDialog();
        }
      }
    },
    handleDropdownCommand(command) {
      if (command === 'info') {
        if (this.$refs['regUserInfoDialog']) {
          this.$refs['regUserInfoDialog'].openDialog({});
        }
        return;
      }
      if (command === 'change_pwd') {
        if (this.$refs['changePasswordDialog']) {
          this.$refs['changePasswordDialog'].openDialog({});
        }
        return;
      }
      if (command === 'account_setting') {
        if (this.$refs['accountSettingDialog']) {
          this.$refs['accountSettingDialog'].openDialog({
            data: this.userInfo,
          });
        }
        return;
      }
      if (command === 'logout') {
        this.storeCommit('SET_USER_INFO', {});
        this.storeCommit('SET_ACCESS_TOKEN', {});
      }
    },
    handleChange(val) {
      if (this.isEmpty(val)) {
        this.handleSearch();
      }
    },
    handleSearch() {
      const _this = this;
      _this.storeCommit('techBlue/SET_SEARCH_VALUE', this.searchValue);
    },
    handleClickItem(item) {
      const _this = this;
      _this.storeCommit('SET_CURR_COLUMN', item);
      this.$nextTick(() => {
        setTimeout(() => {
          $('.content_layout_container').scrollTop(495);
        }, 100);
      });
    },
  },
}
</script>

<style scoped lang="scss">
.page_layout_container {
  width: 100%;
  height: 100%;
  background-color: #F5F7F7;

  .header_container {
    width: 100%;
    height: 80px;
    background-color: #FFFFFF;

    .header {
      height: 100%;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .left_container {
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .website_name {
          font-size: 20px;
          font-weight: 500;
          color: #333333;
          line-height: 28px;
          cursor: pointer;
        }

        .column_item {
          margin-left: 40px;
          font-size: 16px;
          font-weight: 400;
          color: #333333;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          cursor: pointer;

          .column_icon {
            width: 20px;
            height: 20px;
            margin-right: 8px;
          }
        }
      }

      .right_container {
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .search_container {
          margin-right: 40px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          width: 280px;

          .search_select {
            width: 100px;

            :deep(.el-input) {
              .el-input__inner {
                height: 34px;
                line-height: 34px;
                border-radius: 17px 0 0 17px;
                background-color: #F2F5FF;
                border: none;
                text-align: center;
                font-size: 12px;
                font-weight: 600;
                color: #333;
                padding-left: 10px;
                padding-right: 20px;
              }

              .el-input__suffix {
                right: 4px;

                .el-input__icon {
                  color: #333;
                }
              }
            }
          }

          .search_input {
            position: relative;

            :deep(.el-input__inner) {
              height: 34px;
              line-height: 34px;
              border-radius: 0;
              background-color: #F2F5FF;
              border: none;
              font-size: 12px;
              font-weight: 500;
              color: #333;
              padding-right: 20px;
            }

            :deep(.el-input__suffix) {
              right: 3px;
            }

            :deep(.el-input-group__append) {
              border: 0;
              background-color: #F2F5FF;
              border-radius: 0 17px 17px 0;
              padding: 0 10px;

              .search_icon {
                font-size: 20px;
                margin: 7px 0;
                color: #333;
                cursor: pointer;
              }
            }

            &:before {
              content: " ";
              width: 1px;
              height: 16px;
              background-color: #B0B0B0;
              position: absolute;
              left: 0;
              top: 50%;
              transform: translateY(-50%);
            }
          }
        }

        .login_container {
          display: flex;
          align-items: center;
          justify-content: flex-end;

          .login_icon {
            margin-right: 8px;
            font-size: 20px;
            color: #666;

            .img {
              width: 20px;
              height: 20px;
              border-radius: 50%;
            }
          }

          .login_name {
            font-size: 16px;
            font-weight: 400;
            color: #333;
            cursor: pointer;
          }

          :deep(.dropdown_text) {
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }
  }

  .content_layout_container {
    width: 100%;
    padding: 0;
  }

  .footer_container {
    background-color: #434655;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;

    .footer {
      text-align: center;
    }
  }
}
</style>